<template>
  <nav class="navbar navbar-dark bg-dark position-fixed w-100" style="z-index:1040;">
    <div class="container px-3 d-flex align-items-center">

      <!-- Logo -->
      <router-link class="navbar-brand d-flex align-items-center me-4" to="/user/movies">
        <img :src="logo" alt="Logo" height="36" />
      </router-link>

      <!-- Desktop menu (lg+) -->
      <ul class="navbar-nav flex-row gap-1 ms-auto d-none d-lg-flex">
        <li class="nav-item" v-for="item in menu" :key="item.label">
          <router-link :to="item.path" class="nav-link px-2 d-flex align-items-center gap-2" active-class="active">
            <span>{{ item.label }}</span>
          </router-link>
        </li>
      </ul>

      <!-- Mobile burger (< lg) -->
      <button
        class="btn btn-dark d-lg-none ms-auto"
        type="button"
        data-bs-toggle="offcanvas"
        data-bs-target="#mobileMenuOffcanvas"
        aria-controls="mobileMenuOffcanvas"
        aria-label="Открыть меню"
      >
        <i class="bi bi-list fs-4"></i>
      </button>

    </div>
  </nav>

  <!-- Offcanvas (mobile only) -->
  <div
    class="offcanvas offcanvas-end"
    tabindex="-1"
    id="mobileMenuOffcanvas"
    aria-labelledby="mobileMenuOffcanvasLabel"
    style="max-width:280px;"
  >
    <div class="offcanvas-header border-bottom border-secondary">
      <router-link class="navbar-brand d-flex align-items-center" to="/user/movies">
        <img :src="logo" alt="Logo" height="30" />
      </router-link>
      <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Закрыть"></button>
    </div>
    <div class="offcanvas-body p-0">
      <ul class="navbar-nav">
        <li class="nav-item" v-for="item in menu" :key="item.label">
          <router-link
            :to="item.path"
            class="nav-link d-flex align-items-center gap-3 px-4 py-3"
            active-class="active"
            @click="closeOffcanvas"
          >
            <i :class="item.icon" style="width:20px; text-align:center;"></i>
            <span>{{ item.label }}</span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import logo from '@/assets/logo-dreams.png'
import { computed } from 'vue'
import { useStore } from '@/store/store'
import axios from 'axios'

const menu = [
  { label: 'Фильмы',      path: '/user/movies',        icon: 'bi bi-camera-reels' },
  { label: 'Партнеры',    path: '/user/partners',       icon: 'bi bi-people' },
  { label: 'Парковки',    path: '/user/domains/list',   icon: 'bi bi-browser-chrome' },
  { label: 'Лендинги',    path: '/user/landing/list',   icon: 'bi bi-film' },
  { label: 'Новости',     path: '/user/texts/list',     icon: 'bi bi-receipt' },
  { label: 'Зритель',     path: '/customer/dashboard',  icon: 'bi bi-person-video' },
]

const store = useStore()
const user = computed(() => store.getP('user') || {})
const v = computed(() => process.env.VUE_APP_VERSION)

const logout_ = () => {
  store.deleteP('access_token')
  store.deleteP('refresh_token')
  store.deleteP('user')
  delete axios.defaults.headers.common['Authorization']
  window.location.href = '/login'
}

// Закрывает offcanvas при переходе по ссылке
const closeOffcanvas = () => {
  const el = document.getElementById('mobileMenuOffcanvas')
  if (el) {
    const instance = window.bootstrap?.Offcanvas?.getInstance(el)
    instance?.hide()
  }
}
</script>

<style scoped>
.navbar {
  height: 59px;
}

.navbar .nav-link {
  font-size: 0.9rem;
  border-radius: 6px;
  transition: background 0.15s;
}

.navbar .nav-link:hover,
.navbar .nav-link.active {
  background: rgba(255, 255, 255, 0.08);
}

/* Offcanvas тёмная тема */
#mobileMenuOffcanvas {
  background-color: #212529;
  color: #fff;
  border-left: 1px solid rgba(255, 255, 255, 0.08);
}

#mobileMenuOffcanvas .nav-link {
  color: rgba(255, 255, 255, 0.75);
  border-radius: 0;
  transition: background 0.15s, color 0.15s;
}

#mobileMenuOffcanvas .nav-link:hover,
#mobileMenuOffcanvas .nav-link.active {
  background: rgba(255, 255, 255, 0.07);
  color: #fff;
}
</style>